import { createSlice } from '@reduxjs/toolkit';

// api client
import apiClient from './apiClient.js'
const REQUESTS = {
  index: (outputFields = `id`) => {
    return `query {
      missions{
        ${outputFields}
      }
    }`   
  },
  create: ({name, projectId},outputFields = `id`) => {
    return `mutation {
      createMission(mission: {
        name: "${name}",
        projectId: "${projectId}"
      }){
        ${outputFields}
      }
    }`
  },
  update: ({id, name}) => {
    return `mutation {
      editMission( mission: {
        id: "${id}",
        name: "${name}",
      }) {
        id
        name
      }
    }`
  },
  delete: ({id}) => {
    return `mutation {
      deleteMission(id: "${id}")
    }`
  }
}


export const missionsApi = {
  index: async (outputFields, next) => {
    const result = await apiClient.req(REQUESTS.index(outputFields))
    next(result.data.data)
  },
  create: async ({name, projectId}, outputFields, next) => {
    const result = await apiClient.req(REQUESTS.create({name, projectId},outputFields))
    next(result.data.data.createMission)
  },
  update: async ({id, name}, outputFields, next) => {
    const result = await apiClient.req(REQUESTS.update({id, name},outputFields))
    next(result.data.data.editMission)
  },
  delete: async ({id}, next) => {
    const result = await apiClient.req(REQUESTS.delete({id}))
    next(result.data.data.deleteMission)
  }
}

